// extracted by mini-css-extract-plugin
module.exports = {"title":"EditContent_title__1KRhn","row":"EditContent_row__33PLu","btns":"EditContent_btns__36hQU","input":"EditContent_input__2z3p2"};